// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageLinkAnimationFunc() {
  var scrTop, jsAnkerLogin, moveLogin, position, target, getHeadH;
  scrTop = $('#scrPageTop');
  scrTop.on('click', function () {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      1500,
      'easeInOutQuint'
    );
    return false;
  });
}

export function pageMoveAnkerFunc() {
  var headerHeight, position;
  $('a[href^="#"]:not(.notScroll)').each(function () {
    var pageUrl = location.href.split('#')[0];
    if (this.href.indexOf(pageUrl + '#') === 0) {
      var id = this.href.split('#')[1];
      $(this).on('click', function () {
        headerHeight = $('#header').outerHeight(true);
        position = $('#' + id).offset().top - headerHeight;
        $('body,html').animate(
          {
            scrollTop: position,
          },
          1000,
          'easeInOutQuart'
        );
        return false;
      });
    }
  });
}

export function observeFlowNav() {
  const nav = document.querySelector('.p-page-work__contents .c-flow-list');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('.c-flow-list__item'));
  if (!items.length) return;

  const anchorMap = items
    .map((item) => {
      const link = item.querySelector('a[href^="#"]');
      if (!link) return null;
      const id = link.getAttribute('href')?.slice(1);
      if (!id) return null;
      const target = document.getElementById(id);
      if (!target) return null;
      return { item, target };
    })
    .filter(Boolean);

  if (!anchorMap.length) return;

  let ticking = false;
  let currentActiveId = null;

  function updateActiveState() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const centerY = scrollY + windowHeight * 0.4; // 画面上部40%の位置

      let closestSection = null;
      let closestDistance = Infinity;

      // 各セクションの位置をチェック
      anchorMap.forEach(({ item, target }) => {
        const rect = target.getBoundingClientRect();
        const sectionTop = rect.top + scrollY;
        const distance = Math.abs(centerY - sectionTop);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = { item, target };
        }
      });

      // 最も近いセクションをアクティブにする
      if (closestSection) {
        const targetId = closestSection.target.id;

        // 既にアクティブな場合はスキップ
        if (currentActiveId === targetId) {
          ticking = false;
          return;
        }

        currentActiveId = targetId;
        anchorMap.forEach(({ item }) => item.classList.remove('is-active'));
        closestSection.item.classList.add('is-active');
      }

      ticking = false;
    });
  }

  // スクロールイベントで更新（パッシブモード）
  let scrollTimeout;
  window.addEventListener(
    'scroll',
    () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveState, 100);
    },
    { passive: true }
  );

  // 初期状態の設定
  updateActiveState();
}
